import instance from '@apis/instance';
import {
    CancelGiftOrderRequest,
    GiftOrderDetailResponse,
    GiftOrderRequest,
    GiftOrderResponse,
    GiftOrderResultResponse,
} from '@models/gift';

class GiftOrderApi {
    static createGiftOrder(request: GiftOrderRequest): Promise<GiftOrderResponse> {
        return instance.post('/v0/gift-order', request);
    }

    static getGiftOrder(giftOrderNo: string): Promise<GiftOrderDetailResponse> {
        return instance.get(`/v0/gift-order/${giftOrderNo}`);
    }

    static cancelOrder(request: CancelGiftOrderRequest): Promise<never> {
        return instance.post('/v0/gift-order/cancel', request);
    }

    static getGiftOrderResult(orderNo: string): Promise<GiftOrderResultResponse> {
        return instance.get(`/v0/gift-order/${orderNo}/result`);
    }

    static cancelGiftOrder(giftOrderId: string): Promise<never> {
        return instance.post('/v0/gift-order/full-cancel', { giftOrderId });
    }
}

export default GiftOrderApi;
